export default __webpack_public_path__ + "static/media/ThierryMbarushimana.5938f045.webp";